import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import Select from './select'

class SelectForm extends PureComponent {

	constructor(props) {
		super(props)
		this.onChange = this.onChange.bind(this)
	}

	onChange(value) {
		this.props.input.onChange(value)
	}

	render() {

		//Field param should be refactored
		const value = this.props.meta.dirty ? this.props.input.value : this.props.meta.initial || ''
		return <Select
			field={true}
			onChange={this.onChange}
			disabled={this.props.disabled}
			options={this.props.options}
			name={this.props.name}
			placeholder={this.props.placeholder}
			submitting={this.props.submitting}
			fontSize={this.props.fontSize}
			value={this.props.input.value}
			tabIndex={this.props.tabIndex}
			key_name={this.props.key_name}
			text_key={this.props.text_key}
			message={this.props.getMessage(this.props.meta, this.props.name, value)}
			status={this.props.fieldStatus(this.props.meta, this.props.name, value)}
		/>
	}
}

SelectForm.propTypes = {
	fontSize: PropTypes.oneOf(['small', 'medium', 'big']),
}

SelectForm.defaultProps = {
	getMessage: () => '',
	fieldStatus: () => '',
}

export default SelectForm
